import React, { Component } from "react";
import { Modal, Form, Row } from "react-bootstrap";
import Button from "../button/button";

type DeleteModalProps = {
  show?: any;
  deleteUserId?: any;
  confirm?: any;
  cancel?: any;
};

class DeleteModal extends Component<DeleteModalProps, any> {
  render() {
    const userId = this.props.deleteUserId;

    return (
      <Modal
        show={this.props.show}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="modal-header-color">
          <Modal.Title>Are you sure you want to Delete?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="pt-2">
              <Row>
                <div className="col-6">
                  <Button
                    className=""
                    value="Yes"
                    onClick={() => this.props.confirm(userId)}
                  ></Button>
                </div>
                <div className="col-6">
                  <Button
                    className="btn-non-primary btn-default"
                    value="No"
                    onClick={() => this.props.cancel()}
                  ></Button>
                </div>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

export const DeleteUserModal = DeleteModal;
